import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center min-h-screen bg-gray-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("h1", { class: "text-3xl font-bold text-gray-800" }, "Thank You!", -1),
    _createElementVNode("p", { class: "mt-4 text-lg text-gray-600" }, "Thanks for completing our survey!", -1),
    _createElementVNode("svg", {
      class: "w-16 h-16 mt-6 text-blue-600",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor"
    }, [
      _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M12 4v16m8-8H4"
      })
    ], -1)
  ])))
}